export default __webpack_public_path__ + "static/LiteLLM_logo_white-81e31669e4495894596d785585b8754c.png";